import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './News.css';
import newsHero640avif from '../assets/newshero-640.avif';
import newsHero1280avif from '../assets/newshero-1280.avif';
import newsHero1920avif from '../assets/newshero-1920.avif';
import newsHero640webp from '../assets/newshero-640.webp';
import newsHero1280webp from '../assets/newshero-1280.webp';
import newsHero1920webp from '../assets/newshero-1920.webp';
import Footer from '../unAuth/Components/footer';
import { getAllArticles } from '../services/articleService';

function News() {
  const [newsItems, setNewsItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadArticles = async () => {
      setLoading(true);
      const result = await getAllArticles();
      if (result.success) {
        // Transform Firestore articles to match the News component format
        const transformedArticles = result.data.map(article => ({
          slug: article.slug,
          date: article.datePublished,
          headline: article.title,
          summary: article.firstSentence,
          image: article.thumbnail,
          author: article.author
        }));
        setNewsItems(transformedArticles);
      } else {
        console.error('Error loading articles:', result.error);
        setNewsItems([]);
      }
      setLoading(false);
    };

    loadArticles();
  }, []);

  return (
    <div className="news-page-wrapper">
      <div className="news-page container">
        <div className="news-hero">
          <picture>
            <source
              media="(max-width: 640px)"
              srcSet={newsHero640avif}
              type="image/avif"
            />
            <source
              media="(max-width: 1280px)"
              srcSet={newsHero1280avif}
              type="image/avif"
            />
            <source
              srcSet={newsHero1920avif}
              type="image/avif"
            />
            <source
              media="(max-width: 640px)"
              srcSet={newsHero640webp}
              type="image/webp"
            />
            <source
              media="(max-width: 1280px)"
              srcSet={newsHero1280webp}
              type="image/webp"
            />
            <source
              srcSet={newsHero1920webp}
              type="image/webp"
            />
            <img
              src={newsHero1920webp}
              alt="Real World Equity News Hero Background"
              className="news-hero-img"
              fetchPriority="high"
              loading="eager"
            />
          </picture>
          <div className="news-hero-overlay" />
        </div>
        <div className="news-list">
          {loading ? (
            <div style={{ textAlign: 'center', padding: '40px', fontSize: '18px' }}>
              Loading articles...
            </div>
          ) : newsItems.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px', fontSize: '18px' }}>
              No articles available yet.
            </div>
          ) : (
            newsItems.map(item => (
              <div className="news-card" key={item.slug}>
                <img 
                  src={item.image} 
                  alt={item.headline}
                  className="news-card-img"
                  loading="lazy"
                />
                <div className="news-date">{new Date(item.date).toLocaleDateString()}</div>
                {item.author && <div className="news-author">By {item.author}</div>}
                <h3 className="news-headline">{item.headline}</h3>
                <p className="news-summary">{item.summary}</p>
                <Link className="news-readmore" to={`/news/${item.slug}`}>Read More</Link>
              </div>
            ))
          )}
        </div>
        <div style={{ paddingBottom: '2.5rem' }} />
      </div>
      <Footer />
    </div>
  );
}

export default News;
